module.exports = __webpack_public_path__ + "img/ltkholiday-2x.2c2969a.jpg";